import type UserRoleDto from '@/features/authentication/api/dto/UserRoleDto';

import { UserRole } from '@/features/users/models/users';

const userRoleDtoToUserRoleMapping: Record<UserRoleDto, UserRole> = {
  admin: UserRole.ADMIN,
  super_admin: UserRole.SUPER_ADMIN,
  user: UserRole.USER,
};

export default function transformUserRoleFromDto(userRoleDto: UserRoleDto): UserRole {
  return userRoleDtoToUserRoleMapping[userRoleDto];
}
